module.exports = __webpack_public_path__ + "static/img/favicon.fe23091.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicon.svg
// module id = coct
// module chunks = 3